(() => {
  const requests = new WeakMap();
  document.addEventListener('change', async (event) => {
    const picker = event.target.closest('variant-radios, variant-selects');
    if (!picker || Number(picker.dataset.highVariants) <= 250 || !picker.dataset.highVariants) return;
    if (!event.target.matches('select, input[type="radio"]')) return;
    event.stopImmediatePropagation();
    const ids = Array.from(picker.querySelectorAll('.product-form__input')).map(group => {
      const select = group.querySelector('select');
      const selected = select ? select.selectedOptions[0] : group.querySelector('input:checked');
      return selected?.dataset.optionValueId || Array.from(group.querySelectorAll('input[data-option-value-id]')).find(input => input.value === select?.value)?.dataset.optionValueId;
    });
    if (ids.some(id => !id)) return;
    requests.get(picker)?.abort();
    const controller = new AbortController();
    requests.set(picker, controller);
    picker.toggleAddButton(true, '', false);
    picker.setAttribute('aria-busy', 'true');
    const url = new URL(picker.dataset.url, location.origin);
    url.searchParams.set('option_values', ids.join(','));
    url.searchParams.set('section_id', picker.dataset.section);
    const focusId = event.target.id;
    try {
      const response = await fetch(url, {signal: controller.signal});
      if (!response.ok) throw new Error('Variant request failed');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (requests.get(picker) !== controller) return;
      const next = html.getElementById(picker.id);
      if (!next) throw new Error('Variant picker missing');
      const variant = JSON.parse(next.querySelector('[data-selected-variant]').textContent);
      // Preserve the theme's enhanced dropdown and swatches, including their handlers.
      picker.querySelectorAll('input[type="radio"]').forEach(input => {
        const source = html.getElementById(input.id);
        if (!source) return;
        input.checked = source.checked;
        input.classList.toggle('disabled', source.classList.contains('disabled'));
        input.disabled = source.disabled;
      });
      picker.querySelectorAll('.product-form__input').forEach(group => {
        const select = group.querySelector('select');
        const checked = group.querySelector('input:checked');
        if (select && checked) select.value = checked.value;
        const legend = group.querySelector('legend');
        const sourceGroup = next.querySelectorAll('.product-form__input')[Array.from(picker.querySelectorAll('.product-form__input')).indexOf(group)];
        const sourceLegend = sourceGroup?.querySelector('legend');
        if (legend && sourceLegend) legend.innerHTML = sourceLegend.innerHTML;
      });
      picker.querySelector('[data-selected-variant]').textContent = JSON.stringify(variant);
      picker.currentVariant = variant;
      for (const prefix of ['price-', 'Sku-', 'Inventory-', 'Quantity-Rules-', 'Volume-', 'Price-Per-Item-']) {
        const id = prefix + picker.dataset.section;
        const source = html.getElementById(id), target = document.getElementById(id);
        if (source && target) { target.innerHTML = source.innerHTML; target.className = source.className; }
      }
      if (variant) {
        picker.updateURL();
        picker.updateVariantInput();
        picker.updateMedia();
        picker.updatePickupAvailability();
        picker.updateStickyATC(html);
        picker.toggleAddButton(!variant.available, window.variantStrings.soldOut);
      } else {
        picker.setUnavailable();
      }
      document.getElementById(focusId)?.focus({preventScroll:true});
    } catch (error) {
      if (error.name !== 'AbortError') {
        url.searchParams.delete('section_id');
        location.assign(url.href);
      }
    } finally {
      if (requests.get(picker) === controller) picker.removeAttribute('aria-busy');
    }
  }, true);
})();

